import React from 'react';
import PropType from 'prop-types';
import { SUPPORT_EMAIL } from '@/constant/support';

import { Button } from '@/shadcn/button';
import { TestId } from '@/types/testId';
import { Navbar } from '@/components/layouts/header';

type State = {
  hasError: boolean;
  body: string;
};

type Props = {
  children: React.ReactNode;
};

export class UnexpectedErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, body: '' };

  static getDerivedStateFromError(error) {
    document.title = 'An unexpected error occurred';
    return {
      hasError: true,
      body: [
        'Do not modify below this line',
        '------------------------------------------------------------------------',
        Buffer.from(
          JSON.stringify({
            error: {
              name: error.name,
              fileName: error.fileName,
              message: error.message,
              stack: error.stack,
              lineNumber: error.lineNumber,
              columnNumber: error.columnNumber
            },
            window: {
              location: window.location.href,
              screen: {
                width: window.screen.width,
                height: window.screen.height
              },
              navigator: {
                userAgent: navigator.userAgent,
                language: navigator.language
              }
            }
          })
        ).toString('base64')
      ].join('\n')
    };
  }

  static propTypes = {
    children: PropType.node.isRequired
  };

  onEmailButtonClick = () => {
    window.location =
      `mailto:${SUPPORT_EMAIL}?subject=%5BCRASH%5D&body=${encodeURI(
        this.state.body
      )}` as unknown as any;
  };

  render() {
    const { hasError, body } = this.state;

    if (hasError) {
      return (
        <>
          <Navbar />
          <div className="absolute top-1/2 left-1/2 max-w-[500px] -translate-x-1/2 -translate-y-1/2 items-center text-center">
            <h1>An unexpected error occurred.</h1>
            <h1>
              Please send an email to {SUPPORT_EMAIL} with the following body
            </h1>
            <div className="border-border mt-5 h-[200px] overflow-scroll border break-all">
              {body}
            </div>
            <div className="mt-9 flex items-center justify-center">
              <Button
                variant="outline"
                data-cy={TestId.UnexpectedErrorBoundary.SendEmailButton}
                onClick={this.onEmailButtonClick}
              >
                Send email
              </Button>
            </div>
          </div>
        </>
      );
    }
    return this.props.children;
  }
}
